/**
 * @generated SignedSource<<378381372e89ba1e57f7688a4a6ee7e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditPopovers_todo$data = {
  readonly assignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly role: {
      readonly id: string;
      readonly team: {
        readonly id: string;
      };
    };
  }>;
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditDeadlinePopover_todo" | "TodoEditFeedbackPopover_todo" | "TodoEditPrioPopover_todo" | "TodoEditTagsPopover_todo">;
  readonly " $fragmentType": "TodoEditPopovers_todo";
};
export type TodoEditPopovers_todo$key = {
  readonly " $data"?: TodoEditPopovers_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditPopovers_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditPopovers_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditPrioPopover_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditTagsPopover_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditFeedbackPopover_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditDeadlinePopover_todo"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "85f0f02e277b9ec394ebfb6208ea11da";

export default node;
